export default __webpack_public_path__ + "static/media/b17.014e4536.jpg";